import React from "react";
import { BillProps } from "../../../api/services";
import { ColorChip } from "../../../components/Chip";

export const BillRowChips: React.FC<BillProps> = ({
  isDunning,
  isFinal,
  isDirty,
  isDirtyCleared,
  isConsolidated,
  isUnderReview,
  isPaymentPlan,
  isBelowMin,
}) => (
  <>
    {isDirty ? <ColorChip type="Error" label="Dirty" mr={1} /> : null}
    {isDirtyCleared ? <ColorChip label="Dirty - cleared" mr={1} /> : null}
    {isFinal ? <ColorChip type="Info" label="Final Bill" mr={1} /> : null}
    {isPaymentPlan ? (
      <ColorChip type="Warning" label="In Payment Plan" mr={1} />
    ) : null}
    {isDunning ? <ColorChip type="Warning" label="In Dunning" mr={1} /> : null}
    {isUnderReview ? (
      <ColorChip type="Info" label="Under Review" mr={1} />
    ) : null}
    {isConsolidated ? <ColorChip label="Consolidated" mr={1} /> : null}
    {isBelowMin ? <ColorChip type="Success" label="Below Min. Amount" /> : null}
  </>
);
